import { render, staticRenderFns } from "./Vertify.vue?vue&type=template&id=22abbf3d&scoped=true&"
import script from "./Vertify.vue?vue&type=script&lang=js&"
export * from "./Vertify.vue?vue&type=script&lang=js&"
import style0 from "./Vertify.vue?vue&type=style&index=0&id=22abbf3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abbf3d",
  null
  
)

export default component.exports